import { useActivePage } from '@toolpad/core';
import { Outlet, useParams } from 'react-router';
import { Tabs } from '@mui/material';

import { LinkTab } from '@barboxx/admin-components';

import { RootContainer } from '../../components/nav/RootContainer';

export function BusinessDetails() {
    const params = useParams<{ id: string; '*': string }>();
    const currentTab = params['*'];

    const activePage = useActivePage();

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        { title: 'Details', path: `${activePage?.path}/${params.id}` },
    ];

    return (
        <RootContainer maxWidth="lg" breadcrumbs={breadcrumbs}>
            <Tabs
                value={currentTab}
                sx={{ width: '100%' }}
                scrollButtons="auto"
                variant="scrollable"
            >
                <LinkTab
                    to={`/businesses/${params.id}`}
                    value=""
                    label="Info"
                />
                <LinkTab
                    to={`/businesses/${params.id}/employees`}
                    value="employees"
                    label="Employees"
                />
                <LinkTab
                    to={`/businesses/${params.id}/financial`}
                    value="financial"
                    label="Financial"
                />
            </Tabs>

            <Outlet />
        </RootContainer>
    );
}
